import React from 'react';
import {
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from 'react-bootstrap';
import { translate } from 'react-i18next';

class LanguageSwitcher extends React.Component {
  constructor(props) {
    super(props);
    const currentLang = props.i18n.language.split('-')[0];
    this.state = { selectedLang: currentLang };
  }

  changeLanguage(lang) {
    const { i18n } = this.props;
    this.setState({ selectedLang: lang }, () => {
      i18n.changeLanguage(lang);
    });
  }

  render() {
    return (
      <ButtonToolbar id="language-switcher">
        <ToggleButtonGroup
          type="radio"
          name="selected_lang"
          value={this.state.selectedLang}
          onChange={value => this.changeLanguage(value)}
        >
          <ToggleButton id="switch-thai" value={'th'}>
            ไทย
          </ToggleButton>
          <ToggleButton id="switch-english" value={'en'}>
            English
          </ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
    );
  }
}

export default translate('translations')(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/language/LanguageSwitcher.js